import {useEffect, useState} from "react";
import {useNavigate, useParams} from "react-router-dom";
import {AuthRedirectAdmins, PostJSON} from "../../../components/api/webservice";
import {Apis} from "../../../components/api/url";
import {HideMainLoading, HideProgressLoading, ShowProgressLoading} from "../../../components/template/architecture";
import {ShowSnackbar} from "../../../components/template/snackbar";
import '../../../static/css/pages/staff/print-contract.css';
import {CurrencyFormat, StringDigitsConvertToPersian} from "../../../components/techaran/money";
import {GregorianToPersian} from "../../../components/techaran/date-convert";

export const AdminsStaffPrintContractScreen = () => {
    const {staffId} = useParams();
    const [data, setData] = useState({
        loaded: false,
        firstname: '',
        lastname: '',
        tell: '',
        hasPartner: false,
        homeTell: '',
        partnerTell: '',
        partnerFullname: '',
        partnerJob: '',
        teachingGrade: 0,
        isFemale: false,
        birthDate: '2000-01-01',
        certificate: '',
        major: '',
        yearsActive: 0,
        mustHoursPerWeek: 0,
        bankAccountNumber: '',
        hasInsurance: false,
        insuranceDaysPerMonth: 0,
        insuranceCost: 0,
        salary: 0,
        img: '',
        nationalCode: '',
        fatherName: '',
        birthCity: '',
        address: '',
        contractStartTime: '',
        contractExpiresAt: '',
        maxWorkingHoursPerDay: 0,
        cardCode: '',
        isInside: false,
        isProfileComplete: false,
        jobTitle: '',
        isTeacher: false,
        childCount: 0,
        today: '2000-01-01',
        totalContractDays: 0,
    });
    const navigate = useNavigate();
    const fetchData = () => {
        ShowProgressLoading();
        PostJSON(
            Apis.server + '/core/admins/staff/details',
            {
                id: staffId as string,
            },
            true,
            (d: {
                result: string,
                reason: string,
                firstname: string,
                lastname: string,
                tell: string,
                hasPartner: 0 | 1,
                homeTell: string,
                partnerTell: string,
                partnerFullname: string,
                partnerJob: string,
                teachingGrade: number,
                isFemale: 0 | 1,
                birthDate: string,
                certificate: string,
                major: string,
                yearsActive: number,
                mustHoursPerWeek: number,
                bankAccountNumber: string,
                hasInsurance: 0 | 1,
                insuranceDaysPerMonth: number,
                insuranceCost: number,
                salary: number,
                img: string,
                nationalCode: string,
                fatherName: string,
                birthCity: string,
                address: string,
                contractStartTime: string,
                contractExpiresAt: string,
                maxWorkingHoursPerDay: number,
                cardCode: string,
                isInside: 0 | 1,
                isProfileComplete: 0 | 1,
                jobTitle: string,
                isTeacher: 0 | 1,
                childCount: number,
                totalFromSources: number,
                today: string,
            }) => {
                HideProgressLoading();
                if (d.result !== 'OK') {
                    if (d.reason === 'login') {
                        AuthRedirectAdmins();
                    } else if (d.reason === 'access') {
                        navigate('/admins', {replace: true});
                        ShowSnackbar(
                            'شما به این بخش دسترسی ندارید.',
                            'باشه',
                            5000,
                        );
                    } else if (d.reason === 'not-found') {
                        navigate('/admins/staff', {replace: true});
                        ShowSnackbar(
                            'کارمند یافت نشد.',
                            'باشه',
                            5000,
                        );
                    }
                    return;
                }
                let endTime = new Date(d.contractExpiresAt + " 00:00:00").getTime();
                let startTime = new Date(d.contractStartTime + " 00:00:00").getTime();
                let timeLeft = endTime - startTime;
                let days = Math.floor(timeLeft / (1000 * 60 * 60 * 24));
                setData({
                    totalContractDays: days,
                    address: d.address,
                    bankAccountNumber: d.bankAccountNumber,
                    birthCity: d.birthCity,
                    cardCode: d.cardCode,
                    birthDate: d.birthDate,
                    certificate: d.certificate,
                    childCount: d.childCount,
                    contractExpiresAt: d.contractExpiresAt,
                    contractStartTime: d.contractStartTime,
                    firstname: d.firstname,
                    fatherName: d.fatherName,
                    hasInsurance: d.hasInsurance === 1,
                    hasPartner: d.hasPartner === 1,
                    homeTell: d.homeTell,
                    salary: d.salary,
                    isTeacher: d.isTeacher === 1,
                    jobTitle: d.jobTitle,
                    lastname: d.lastname,
                    insuranceCost: d.insuranceCost,
                    insuranceDaysPerMonth: d.insuranceDaysPerMonth,
                    isFemale: d.isFemale === 1,
                    img: d.img,
                    isProfileComplete: d.isProfileComplete === 1,
                    major: d.major,
                    maxWorkingHoursPerDay: d.maxWorkingHoursPerDay,
                    mustHoursPerWeek: d.mustHoursPerWeek,
                    nationalCode: d.nationalCode,
                    partnerFullname: d.partnerFullname,
                    tell: d.tell,
                    partnerJob: d.partnerJob,
                    isInside: d.isInside === 1,
                    partnerTell: d.partnerTell,
                    teachingGrade: d.teachingGrade,
                    yearsActive: d.yearsActive,
                    loaded: true,
                    today: d.today,
                });
                document.title = d.firstname + " " + d.lastname + ' | منابع انسانی | اتوماسیون';
            },
            () => {
            },
            AuthRedirectAdmins,
        ).then(void 0);
    };
    useEffect(() => {
        HideMainLoading();
        fetchData();
        document.title = "پرینت قرارداد | منابع انسانی | اتوماسیون";
    }, []);
    return (
        <>
            {
                data.loaded ?
                    <div className="print-contract-screen">
                        <div className="print-contract-logo">
                            <img src="/logo.png" alt="اتوماسیون"/>
                        </div>
                        <div className="print-contract-title">
                            <b>قرارداد موقت کارکنان</b>
                            <span>دبستان دخترانه غیرانتفاعی نهال</span>
                        </div>
                        <div className="print-contract-date">
                    <span>
                        شماره:
                        {" ق-" + StringDigitsConvertToPersian(staffId as string)}
                    </span>
                            <div/>
                            <span>تاریخ:
                                {" " + StringDigitsConvertToPersian(GregorianToPersian(data.today).replaceAll('-', '/'))}
                    </span>
                        </div>
                        <div className="print-contract-content">
                    <span>این قرارداد بین
                        موسس
                        <b> دبستان دخترانه نهال کاشمر </b>
                        سرکار خانم
                        <b> سمیرا کاویانی </b>
                        فرزند محمدرضا با کدملی
                        <b> ۰۸۹۰۱۸۵۰۴۲ </b>
                        متولد
                        <b> ۱۳۷۰ </b>
                        صادره از شهرستان کاشمر به عنوان موسس دبستان دخترانه نهال کاشمر که طرف اول قرارداد نامیده می‌شود.
                    </span>
                            <span>و
                                {" " + (data.isFemale ? 'خانم' : 'آقای')}
                                <b>{data.firstname + " " + data.lastname}</b>
                        فرزند
                        <b>{data.fatherName}</b>
                        با کد ملی
                        <b>{StringDigitsConvertToPersian(data.nationalCode)}</b>
                        متولده
                        <b>{StringDigitsConvertToPersian(GregorianToPersian(data.birthDate).replaceAll('-', '/'))}</b>
                        صادره از
                        <b>{data.birthCity}</b>
                        با مدرک تحصیلی
                        <b>{data.certificate}</b>
                        در رشته
                        <b>{data.major}</b>
                        با تلفن همراه
                        <b>{StringDigitsConvertToPersian(data.tell.replaceAll('+98', '0'))}</b>
                        و نشانی
                        <b>{StringDigitsConvertToPersian(data.address)}</b>
                        و تلفن منزل:
                        <b>{StringDigitsConvertToPersian(data.homeTell.replaceAll('+98', '0'))}</b>
                    </span>
                            <span>که طرف دوم قرارداد نامیده می‌شود به عنوان همکار
                        <b>{(data.jobTitle === '' ? '...' : data.jobTitle)}</b>
                        به شرح ذیل منعقد و طرفین قرارداد، مندرجات ذیل را قبول و ضمن امضا آن به انجام کامل آن تعهد نمودند.
                    </span>
                            <span>۱- مدت قرارداد
                        <b>{StringDigitsConvertToPersian(data.totalContractDays) + " روز"}</b>
                                می‌باشد که از تاریخ
                                <b>{StringDigitsConvertToPersian(GregorianToPersian(data.contractStartTime).replaceAll('-', '/'))}</b>
                                تا تاریخ
                                <b>{StringDigitsConvertToPersian(GregorianToPersian(data.contractExpiresAt).replaceAll('-', '/'))}</b>
                                می‌باشد.
                    </span>
                            <span>
                                ۲- به موجب این قرارداد ساعت کار هفته‌ای
                                <b>{StringDigitsConvertToPersian(data.mustHoursPerWeek)}</b>
                                ساعت می‌باشد.
                            </span>
                            <span>۳- میزان حقوق ماهیانه براساس شاخص های مصوب و میزان ساعت کار
                                <b>{CurrencyFormat(data.salary * 10)}</b>
                                ریال می‌باشد. که پس از کسر حق بیمه شخص به حساب نامبرده واریز خواهد شد.
                            </span>
                            <span>۴- میزان ساعت کار در روز حداکثر
                                <b>{CurrencyFormat(data.maxWorkingHoursPerDay)}</b>
                                ساعت می‌باشد.
                            </span>
                            <span>
                                ۵- شرح وظایف طرف دوم قرارداد به وی به صورت مکتوب اعلام شده است.
                            </span>
                            <span>
                                ۶- رعایت الزامات محیط کار و قوانین و مقررات اداری مربوطه الزامی می‌باشد.
                            </span>
                            <span>
                                ۷- در بازه زمانی ساعت کلاس درس، کلیه مسئولیت‌ها و عواقب کاری اداری و فانونی با آموزگار محترم می‌باشد.
                            </span>
                            <span>
                                 ۸- در صورت عدم انجام وظیفه، غیبت‌های مکرر یا طولانی، تخطی از مقررات اداری(تنبیه، توهین،...) طرف اول می‌تواند بدون مراجعه به مراجع دیگر قرارداد را یک طرفه فسخ نماید.
                            </span>
                            <span>
                                ۹- حضور در جلسات مرتبط شغلی مانند شورای معلمان، شورای مدرسه، گروه های آموزشی و حسب ... اعلام آموزشگاه الزامی می‌باشد.
                            </span>
                        </div>
                        <div className="print-contract-sign">
                            <div className="row">
                                <div className="col-6">
                                    <span>امضای کارفرما</span>
                                    <b>سرکار خانم سمیرا کاویانی</b>
                                </div>
                                <div className="col-6">
                                    <span>امضای همکار</span>
                                    <b>{data.firstname + " " + data.lastname}</b>
                                </div>
                            </div>
                        </div>
                    </div> : null
            }
        </>
    );
};